import { render, staticRenderFns } from "./mianze.vue?vue&type=template&id=30f8ca2f&scoped=true&"
import script from "./mianze.vue?vue&type=script&lang=js&"
export * from "./mianze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f8ca2f",
  null
  
)

export default component.exports